import mitt, { Emitter } from 'mitt';

import { IEventDispatcher, SensorEventMap } from '../interfaces/IEventDispatcher';

export class EventDispatcher implements IEventDispatcher {
  public emitter: Emitter<SensorEventMap> = mitt<SensorEventMap>();

  emit<K extends keyof SensorEventMap>(event: K, payload?: SensorEventMap[K]) {
    this.emitter.emit(event, payload);
  }

  on<K extends keyof SensorEventMap>(event: K, handler: (payload: SensorEventMap[K]) => void) {
    this.emitter.on(event, handler);

    return () => this.emitter.off(event, handler);
  }

  off<K extends keyof SensorEventMap>(event: K, handler: (payload: SensorEventMap[K]) => void) {
    this.emitter.off(event, handler);
  }
}
